import { Icon } from "@mui/material";

export const ChangeTypeIcons = (props: {
  type: string;
  date: string;
  time: string;
}) => {
  const CreateIcon = () => {
    return (
      <div
        style={{
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 0,
          width: 60,
        }}
      >
        <span style={{ fontSize: "small" }}>{props.time}</span>
        <div
          style={{
            borderRadius: "100%",
            background: "linear-gradient(to bottom, #2ECF46, #1A8F00)",
            width: 40,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 4px gray",
            color: "white",
          }}
        >
          <Icon fontSize="medium">add_circle </Icon>
        </div>
        {/* <span>{props.type}</span> */}
      </div>
    );
  };

  const EditIcon = () => {
    return (
      <div
        style={{
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 0,
          width: 60,
        }}
      >
        <span style={{ fontSize: "small" }}>{props.time}</span>
        <div
          style={{
            borderRadius: "100%",
            background: "linear-gradient(to bottom, #FFFF00, #e18900)",
            width: 40,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 4px gray",
            color: "white",
          }}
        >
          <Icon fontSize="medium">drive_file_rename_outline_icon </Icon>
        </div>
        {/* <span>{props.type}</span> */}
      </div>
    );
  };

  const DeleteIcon = () => {
    return (
      <div
        style={{
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 0,
          width: 60,
        }}
      >
        <span style={{ fontSize: "small" }}>{props.time}</span>
        <div
          style={{
            borderRadius: "100%",
            background: "linear-gradient(to bottom, #FFAEAF, #D40D10)",
            width: 40,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 4px gray",
            color: "white",
          }}
        >
          <Icon fontSize="medium">delete_outline_icon</Icon>
        </div>
        {/* <span style={{ maxWidth: 100, textAlign: "center" }}>{props.type}</span> */}
      </div>
    );
  };

  const ReorderIcon = () => {
    return (
      <div
        style={{
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 0,
          width: 60,
        }}
      >
        <span style={{ fontSize: "small" }}>{props.time}</span>
        <div
          style={{
            borderRadius: "100%",
            background: "linear-gradient(to bottom, #6f7bff,#2633d4)",
            width: 40,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 4px gray",
            color: "white",
          }}
        >
          <Icon fontSize="medium">wifi_protected_setup</Icon>
        </div>
      </div>
    );
  };

  const RevertIcon = () => {
    return (
      <div
        style={{
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 0,
          width: 60,
        }}
      >
        <span style={{ fontSize: "small" }}>{props.time}</span>
        <div
          style={{
            borderRadius: "100%",
            background: "linear-gradient(to bottom, #6f7bff,#2633d4)",
            width: 40,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 4px gray",
            color: "white",
          }}
        >
          <Icon fontSize="medium">undo_icon</Icon>
        </div>
      </div>
    );
  };

  const AdoptIcon = () => {
    return (
      <div
        style={{
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 0,
          width: 60,
        }}
      >
        <span style={{ fontSize: "small" }}>{props.time}</span>
        <div
          style={{
            borderRadius: "100%",
            background: "linear-gradient(to bottom, #6f7bff,#2633d4)",
            width: 40,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 4px gray",
            color: "white",
          }}
        >
          <Icon fontSize="medium">publish_icon</Icon>
        </div>
      </div>
    );
  };

  const OtherIcon = () => {
    return (
      <div
        style={{
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 0,
          minWidth: 60,
          maxWidth: 60,
        }}
      >
        <span style={{ fontSize: "small", color: "darkblue" }}>
          {props.time}
        </span>
        <div
          style={{
            borderRadius: "100%",
            background: "linear-gradient(to bottom, #6f7bff,#2633d4)",
            width: 40,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 4px gray",
            color: "white",
          }}
        >
          <Icon fontSize="medium">info_icon</Icon>
        </div>
        {/* <span
          style={{
            color: "darkblue",
            textAlign: "center",
          }}
        >
          {props.type}
        </span> */}
      </div>
    );
  };

  switch (props.type) {
    case "Create":
      return <CreateIcon />;
    case "Delete":
      return <DeleteIcon />;
    case "Update":
      return <EditIcon />;
    case "Remove Assessed Skill":
      return <DeleteIcon />;
    case "Remove Prerequisite":
      return <DeleteIcon />;
    case "Add Prerequisite":
      return <CreateIcon />;
    case "Add Competency Assessed Skill":
      return <CreateIcon />;
    case "Reorder Assessed Skills":
      return <ReorderIcon />;
    case "Adopt Version":
      return <AdoptIcon />;
    case "Revert Version":
      return <RevertIcon />;
    // Default case
    default:
      return <OtherIcon />;
  }
};
